import Api from '../../../api/delivery/deliveryProperiesApi';

export default {
  namespaced: true,
  state: {
    properties: []
  },
  mutations:  {
    setProperties(state, {data}) {
      state.properties = data;
    }
  },
  actions: {
    async fetch({commit, dispatch}) {
      try {
        const response = await Api.fetch();
        commit('setProperties', {data: response.data});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject();
      }
    }
  }
}
